<app-header></app-header>
<ion-content class="customContainer">
  <ion-grid class="subHeader">
    <ion-row class="ion-justify-content-around ion-align-items-center">
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-toolbar mode="md">
          <ion-buttons slot="start">
            <ion-back-button defaultHref="/home"></ion-back-button>
          </ion-buttons>
          <ion-title class="page-title" slot="start">{{'search' | language : 'Search'}}</ion-title>
        </ion-toolbar>
      </ion-col>
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-searchbar #searchBar search-icon="search-outline" (ionChange)="searchSuggestions($event)" [debounce]="1000"
          enterkeyhint="search" show-clear-button="focus"
          placeholder="{{searchquery ? searchquery : 'productorcategoryname...' | language: 'Product or category name...'}}"
          autofocus mode="md" (keypress)="search($event)">
        </ion-searchbar>
      </ion-col>
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-item lines="none" class="addCatalog">
          <ion-buttons slot="end" class="buttons">
            <ion-button (click)="routeToHome()">
              <ion-icon name="home"></ion-icon>
            </ion-button>
            <ion-button (click)="onAdd()">
              <ion-icon color="primary" size="large" name="add-circle"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-progress-bar type="indeterminate" *ngIf="commonService.isLoading" mode="ios"></ion-progress-bar>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-container>
    <div class="suggestion-results" *ngIf="suggestion?.length > 0">
      <ion-list>
        <ion-item mode="md" *ngFor="let product of suggestion" (click)="productSearch(product.prdNm)">
          <p>{{product.prdNm}}</p>
        </ion-item>
      </ion-list>
    </div>
    <div *ngIf="searchresult">
      <div class="search-results">
        <ion-segment mode="md" [(ngModel)]="searchSegment" class="main-segment ion-justify-content-start">
          <ion-segment-button value="products">
            <ion-label>{{'Products' | language:'Products'}}</ion-label>
          </ion-segment-button>
          <ion-segment-button value="category">
            <ion-label>{{'category'| language:'Category'}}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
      <div [ngSwitch]="searchSegment">
        <div *ngSwitchCase="'products'" class="ion-no-margin">
          <ion-grid>
            <ion-row>
              <ng-container *ngFor="let product of searchresult?.all_products;">
                <ion-col size="4" size-sm="4" size-md="2" size-lg="2">
                  <div class="card" (click)="updateProduct(product, product?.checked);">
                    <ion-checkbox mode="md" color="primary" [disabled]="product?.status == 'published'"
                      [(ngModel)]="product.checked"></ion-checkbox>
                    <label (click)="product.checked = !product.checked">
                      <ion-img loading="lazy" class="productimg"
                        [src]="product?.media?.imgTh || product?.media?.img1"></ion-img>
                      <p class="subname">{{product.prdNm | titlecase}}</p>
                    </label>
                  </div>
                </ion-col>
              </ng-container>
            </ion-row>
          </ion-grid>
        </div>
        <div *ngSwitchCase="'category'" class="ion-no-margin">
          <div class="category">
            <ion-segment-button *ngFor="let categories of searchresult?.categories" mode="ios"
              (click)="selectCategory(categories)" class="rounded-segment-button ion-text-capitalize"
              [ngClass]="{'active': selectedCategory.name === categories.name}">
              {{categories.name |language :categories.name }} ({{categories.product_count}})
            </ion-segment-button>
          </div>
          <ion-grid>
            <ion-row>
              <ng-container *ngFor="let product of selectedCategory.products;">
                <ion-col size="4" size-sm="4" size-md="2" size-lg="2">
                  <div class="card" (click)="updateProduct(product, product?.checked);">
                    <ion-checkbox mode="md" color="primary" [(ngModel)]="product.checked"
                      [disabled]="product?.status == 'published'"></ion-checkbox>
                    <label (click)="product.checked = !product.checked">
                      <ion-img loading="lazy" class="productimg"
                        [src]="product?.media?.imgTh || product?.media?.img1"></ion-img>
                      <p class="subname">{{product.prdNm | titlecase}}</p>
                    </label>
                  </div>
                </ion-col>
              </ng-container>
            </ion-row>
          </ion-grid>
        </div>
      </div>
    </div>
  </ng-container>
</ion-content>